(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
$(function() {
  var header_height = $('#top_navbar').height() + 5;
  if ($('#top_alert').length > 0) {
    header_height += $('#top_alert').height();
  }
  $('.header-sticky').stickybits({ stickyBitStickyOffset: header_height, useStickyClasses: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-hero"] && !Shopify.designMode) return;
  try {
    
$(function () {
  initCollectionsHero();

  $(document).on('shopify:section:load', function(e) {
    initCollectionsHero();
  });
  $(document).on('shopify:section:reorder', function(e) {
    initCollectionsHero();
  });
  $(document).on('shopify:block:select', function(e) {
    initCollectionsHero(event.detail.blockId);
  });
});

function initCollectionsHero(selectedCell) {
  var $collections_hero = $('#collections_hero').flickity({
    autoPlay: 7000,
    wrapAround: true,
    lazyLoad: 1,
    selectedAttraction: 0.15,
    friction: 0.6,
    prevNextButtons: false,
    pageDots: false
  });

  var $collections_hero_nav = $('#collections_hero_nav').flickity({
    asNavFor: "#collections_hero",
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });

  $('#collections_hero .previous').on( 'click', function() {
    $collections_hero.flickity('previous');
  });

  $('#collections_hero .next').on( 'click', function() {
    $collections_hero.flickity('next');
  });

  if (selectedCell !== undefined) {
    $collections_hero.flickity('select', $('#cell_' + selectedCell).index());

    SVGInject.setOptions({
      onFail: function(img, svg) {
        img.classList.remove('injectable');
      }
    });
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
$(function () {
  initHero();

  $(document).on('shopify:section:load', function(e) {
    initHero();
  });
  $(document).on('shopify:section:reorder', function(e) {
    initHero();
  });
  $(document).on('shopify:block:select', function(e) {
    initHero(event.detail.blockId);
  });
});

function initHero(selectedCell) {
  var $superhero = $('#superhero').flickity({
    autoPlay: 5000,
    wrapAround: true,
    lazyLoad: 1, 
    selectedAttraction: 0.15,
    friction: 0.6,
    prevNextButtons: false
  });

  $superhero.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
    if (typeof cellIndex == 'number') {
      $superhero.flickity('selectCell', cellIndex);
    }
  });
  
  $('.carousel-cell video').each(function (i, video) {
    video.play();
  });

  window.dispatchEvent(new Event('resize'));

  if (selectedCell !== undefined) {
    $superhero.flickity('select', $('#cell_' + selectedCell).index());
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
$(function () {
  initHero();

  $(document).on('shopify:section:load', function(e) {
    initHero();
    SVGInject(document.querySelectorAll('img.injectable'));
  });
  $(document).on('shopify:section:reorder', function(e) {
    initHero();
    SVGInject(document.querySelectorAll('img.injectable'));
  });
  $(document).on('shopify:block:select', function(e) {
    initHero();
    SVGInject(document.querySelectorAll('img.injectable'));
  });
});

function initHero() {
  const hero_carousel = new Carousel(document.querySelector("#homepage_hero"), {
    preload: 1,
    friction: 0.6,
    Autoplay: {
      timeout: 5000
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
var feed = new Instafeed({
  limit: 6,
  template: '<a class="col-lg-2 col-md-4 col-6 instagram-image instagram-{{orientation}}" href="{{link}}" rel="noopener noreferrer"><img src="{{image}}" alt="{{caption}}"></a>',
  accessToken: InstagramToken,
  error: function() {
    $("#instagram").remove();
  },
  success: function() {
    $("#instagram").prepend('<h6><a href="https://instagram.com/fangamernet">Fangamer on Instagram</a></h6>');
  }
});
feed.run();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signups"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $(document).on("click", ".signups-button", function(e){
    e.preventDefault();
    var signup_modal_id = $(this).attr('data-modaltarget');
    var signup_modal_target = $(this).attr('data-modalcontent');
    $(signup_modal_id).modal("show");
    $(signup_modal_id + '_content').html("<iframe frameborder='0'></iframe>");
    $(signup_modal_id + '_content').find('iframe').first().attr('src', signup_modal_target);
  });

  setTimeout( function(){
  $(".ib-parts").addClass("ontext");
  } , 6000);

});

  } catch(e) { console.error(e); }
})();
})();
